import { render, staticRenderFns } from "./HotCategories.vue?vue&type=template&id=060da81e&scoped=true&"
import script from "./HotCategories.vue?vue&type=script&lang=js&"
export * from "./HotCategories.vue?vue&type=script&lang=js&"
import style0 from "./HotCategories.vue?vue&type=style&index=0&id=060da81e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060da81e",
  null
  
)

export default component.exports